import React, { Component } from 'react';
import './UserHeader.css';
import PropTypes from 'prop-types';
import userPng from '../../images/user.png';
import dropDownArrowPng from '../../images/dropdown-arrow.png';
import Account from 'components/header/Account';
import Popover from 'react-awesome-popover';
import { ServiceProviderTypes } from 'domain/service-provider-type-enum';

class UserHeader extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    accounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onAccountClick: PropTypes.func.isRequired,
    onAddAccount: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
  };

  handleAccountClick = (event, acc) => {
    event.preventDefault();
    this.props.onAccountClick(acc);
  };

  handleAddAccount = (event) => {
    event.preventDefault();
    this.props.onAddAccount();
  };

  handleLogout = (event) => {
    event.preventDefault();
    this.props.onLogout();
  };

  handleCustomerSupport = (event) => {
    const { currentUser } = this.props;
    event.preventDefault();
    const url =
      `${process.env.REACT_APP_CLICKUP_FORM_URL}` +
      `?Name=${encodeURIComponent(
        currentUser.first_name + ' ' + currentUser.last_name
      )}` +
      `&Email=${encodeURIComponent(currentUser.email)}` +
      `&${encodeURIComponent('Phone Number')}=${encodeURIComponent(
        currentUser.phone_number
      )}` +
      `&${encodeURIComponent('User Id')}=${encodeURIComponent(
        currentUser.uid
      )}` +
      `&Role=${encodeURIComponent(
        ServiceProviderTypes[currentUser.accountable_type] || 'Spackle'
      )}`;
    window.open(url, '_blank');
  };

  render() {
    const { currentUser, accounts } = this.props;

    return (
      <div className="user-header">
        <div className="user-image">
          <img src={userPng} alt="user" />
        </div>

        <div className="user-name">
          <span>Hello</span>
          <span>{currentUser.first_name}</span>
        </div>

        <div className="user-options">
          <Popover arrow={false} placement="bottom-end">
            <img src={dropDownArrowPng} alt="options" />
            <div className="options-container">
              <ul>
                {accounts.map((acc) => {
                  return (
                    <li
                      key={acc.user.id}
                      className={
                        currentUser.id === acc.user.id ? 'selected' : ''
                      }
                      onClick={(e) => this.handleAccountClick(e, acc)}
                    >
                      <Account account={acc.user} />
                    </li>
                  );
                })}
                <li onClick={this.handleAddAccount}>Add Account</li>
                <li onClick={this.handleCustomerSupport}>Customer Support</li>
                <li onClick={this.handleLogout}>Logout</li>
              </ul>
            </div>
          </Popover>
        </div>
      </div>
    );
  }
}

export default UserHeader;



// WEBPACK FOOTER //
// ./src/components/header/UserHeader.js